import { FunctionComponent } from 'react'
import { Box, Typography } from '@black-bear-energy/rucksack'
import { ArrayLocationAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { ArrayLocationChip } from 'components/common/ArrayLocationChip'
import { BatteryChargingFullRounded } from '@mui/icons-material'

export const ArrayAndStorageIcon: FunctionComponent<
  ArrayAndStorageIconProps
> = ({ arrayLocation, storageSize }) => {
  // If the site RFP has non-zero battery size and has an array location
  // that is anything other than storage, display an icon to indicate that
  // a battery is included in the project
  const showBatteryIcon =
    storageSize && arrayLocation != ArrayLocationAPIResponse.Storage

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        fontWeight: 'normal',
      }}
    >
      {arrayLocation && <ArrayLocationChip arrayLocation={arrayLocation} />}
      {showBatteryIcon && (
        <>
          <Typography>+</Typography>
          <BatteryChargingFullRounded sx={{ color: '#4CAF50' }} />
        </>
      )}
    </Box>
  )
}

export interface ArrayAndStorageIconProps {
  arrayLocation?: ArrayLocationAPIResponse | null
  storageSize?: number | null
}
